"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

require("../../../src/components/all.sass");

var _useSiteMetadata2 = require("../../../src/hooks/use-site-metadata");

var _gatsby = require("gatsby");

var _Footer = _interopRequireDefault(require("../main/Footer"));

var _Navbar = _interopRequireDefault(require("../main/Navbar"));

var TemplateWrapper = function TemplateWrapper(_ref) {
  var langKey = _ref.langKey,
      slug = _ref.slug,
      children = _ref.children;

  var _useSiteMetadata = (0, _useSiteMetadata2.useSiteMetadata)(),
      title = _useSiteMetadata.title,
      description = _useSiteMetadata.description,
      logo = _useSiteMetadata.logo;

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", null,
    /*#__PURE__*/
    _react["default"].createElement(_reactHelmet.Helmet, null,
    /*#__PURE__*/
    _react["default"].createElement("html", {
      lang: "en"
    }),
    /*#__PURE__*/
    _react["default"].createElement("title", null, title),
    /*#__PURE__*/
    _react["default"].createElement("meta", {
      name: "description",
      content: description
    }),
    /*#__PURE__*/
    _react["default"].createElement("link", {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "".concat((0, _gatsby.withPrefix)("/"), "files/favicon/apple-touch-icon.png")
    }),
    /*#__PURE__*/
    _react["default"].createElement("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "".concat((0, _gatsby.withPrefix)("/"), "files/favicon/favicon-32x32.png")
    }),
    /*#__PURE__*/
    _react["default"].createElement("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "".concat((0, _gatsby.withPrefix)("/"), "files/favicon/favicon-16x16.png")
    }),
    /*#__PURE__*/
    _react["default"].createElement("link", {
      rel: "mask-icon",
      href: "".concat((0, _gatsby.withPrefix)("/"), "files/favicon/safari-pinned-tab.svg"),
      color: "#f8971d"
    }),
    /*#__PURE__*/
    _react["default"].createElement("link", {
      rel: "shortcut icon",
      href: "".concat((0, _gatsby.withPrefix)("/"), "files/favicon/favicon.ico")
    }),
    /*#__PURE__*/
    _react["default"].createElement("meta", {
      name: "apple-mobile-web-app-title",
      content: description
    }),
    /*#__PURE__*/
    _react["default"].createElement("meta", {
      name: "application-name",
      content: description
    }),
    /*#__PURE__*/
    _react["default"].createElement("meta", {
      name: "msapplication-TileColor",
      content: "#f8971d"
    }),
    /*#__PURE__*/
    _react["default"].createElement("meta", {
      name: "msapplication-config",
      content: "".concat((0, _gatsby.withPrefix)("/"), "files/favicon/browserconfig.xml")
    }),
    /*#__PURE__*/
    _react["default"].createElement("meta", {
      name: "theme-color",
      content: "#ffffff"
    }),
    /*#__PURE__*/
    _react["default"].createElement("link", {
      rel: "manifest",
      href: "".concat((0, _gatsby.withPrefix)("/"), "files/favicon/manifest.json")
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        position: "relative",
        minHeight: "100vh"
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_Navbar["default"], {
      langKey: langKey,
      slug: slug,
      logo: logo
    }), children,
    /*#__PURE__*/
    _react["default"].createElement(_Footer["default"], null)))
  );
};

var _default = TemplateWrapper;
exports["default"] = _default;